import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  states: [],
};

const stateMasterSlice = createSlice({
  name: 'stateMaster',
  initialState: initialState,
  reducers: {
    setStateMaster(state, { payload }) {
      state.states = payload;
    },
  },
});

export const { setStateMaster } = stateMasterSlice.actions;

export const stateMasterReducer = stateMasterSlice.reducer;
